import { Component, inject, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { Api } from '../../services/api';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute } from '@angular/router';
import { MdlCall } from '../../components/mdl-call/mdl-call';
import { MdlTask } from '../../components/mdl-task/mdl-task';
import { MdlEvent } from '../../components/mdl-event/mdl-event';
import { Mdlfilterectivities } from '../../components/mdl-filter-activities/mdl-filter-activities';
import { MdlChangeOwnerComponent } from '../../components/mdl-change-owner/mdl-change-owner';
import { NavAccount } from '../../components/account/nav-account/nav-account';
import { MdlManageAccount } from '../../components/mdl-manage-account/mdl-manage-account';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { AccountService } from '../../services/account.service';
import { FormsModule } from '@angular/forms';
import { MdlNewTaskComponent } from '../../components/mdl-new-task/mdl-new-task';
import { MdlSendMail } from '../../components/mdl-send-mail/mdl-send-mail';
import { MdlNewEventComponent } from '../../components/mdl-new-event/mdl-new-event';

interface Contacto{
  item: number,
  nombre: string,
  telefono: string,
  correo: string,
  cargo: string
}

@Component({
  selector: 'app-account-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    NavAccount,
    FormsModule
  ],
  templateUrl: './account-detail.html',
  styleUrl: './account-detail.css'
})
export class AccountDetail implements OnInit {
  public account: any = {};
  public api = inject(Api);
  public accountService = inject(AccountService);
  public menuOpen: boolean = false;
  public isLoading: boolean = true;
  public errorMessage: string = '';
  public account_id: string = '';

  public showInfoSection: boolean = true;
  public showDetailsSection: boolean = true;
  public showHistorySection: boolean = true;

  public editInfo: boolean = false;
  public editDetails: boolean = false;

  public editableAccount: any = {};
  public industrias: any[] = [];


  public tableData : Contacto [] = [];

  readonly dialog = inject(MatDialog);

  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private ngZone: NgZone 
  ) {}

  ngOnInit(): void {
    console.log('[AccountDetail] ngOnInit iniciado');
    this.route.params.subscribe(params => {
      const accountId = params['id'];
      if (accountId) {
        this.account_id = accountId;
        this.loadAccount(accountId);
      } else {
        this.errorMessage = 'No se proporcionó un ID de cuenta válido';
        this.isLoading = false;
      }
    });
      this.getIndustries();

  }

  loadAccount(id: string): void {
    this.isLoading = true;
    this.errorMessage = '';
    this.api.getAccountById({id: id}).subscribe({
      next: (data: any) => {
        this.account = data.cuenta;
        console.log(this.account.contactos);
        for (let i = 0; i < this.account.contactos.length; i++) {
          let contacto = this.account.contactos[i];
          this.tableData
          .push({
            item: i, 
            nombre: contacto.nombre + ' ' + contacto.apellido,
            telefono: contacto.telefono,
            correo:contacto.email,
            cargo: contacto.cargo
          });
        }
        console.log(this.tableData);
        this.accountService.setTableData(this.tableData)
        this.isLoading = false;
      },
      error: (err: any) => {
        this.errorMessage = 'Error al cargar los datos de la cuenta';
        this.isLoading = false;
      }
    });
  }

  openManageAccount(data:any): void {
    this.dialog.open(MdlManageAccount, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        account: this.account, 
        mode: 'edit',
        account_id: this.account_id
      }
    });
  }

  openCreateAccount(): void {
    this.dialog.open(MdlManageAccount, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'create'
      }
    });
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    this.cdr.detectChanges();
  }

  onOptionSelect(option: string) {
    console.log('Seleccionaste:', option);
    this.menuOpen = false;
    this.cdr.detectChanges();
  }

  openNewCall(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.account,
        tipo: 'ACC',
        mode: 'call',

      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewTask(): void {
   this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.account,
        mode: 'task',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewEvent(): void {
    this.dialog.open(MdlNewEventComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        prospecto: this.account 
      }
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewfilterActivities(): void {
    this.dialog.open(Mdlfilterectivities, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class'
    });
  }

  openNewChangeOwner(): void {
    this.dialog.open(MdlChangeOwnerComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: { prospectData: this.account } 
    }).afterClosed().subscribe(result => {
      if (result) {
        console.log('Nuevo propietario:', result);
      }
    });
  }

    openMdlDeleteAccount(){
      this.dialog.open(MdlDelete, {
        minWidth: '500px',
        minHeight: '260px',
        panelClass: 'mat-dlg-class',
        data:{
          mode: 'account',
          id: this.account_id
        }
      })
    }


    toggleSection(section: 'info' | 'details' | 'history') {
  if (section === 'info') {
    this.showInfoSection = !this.showInfoSection;
  } else if (section === 'details') {
    this.showDetailsSection = !this.showDetailsSection;
  } else if (section === 'history') {
    this.showHistorySection = !this.showHistorySection;
  }
}

toggleEdit(section: 'info' | 'details') {
  if (section === 'info') {
    this.editInfo = !this.editInfo;
  } else if (section === 'details') {
    this.editDetails = !this.editDetails;
  }

  if (this.editInfo || this.editDetails) {
    this.editableAccount = { ...this.account };
  }
}

cancelEdit(section: 'info' | 'details') {
  if (section === 'info') this.editInfo = false;
  if (section === 'details') this.editDetails = false;
  this.editableAccount = { ...this.account };
}

saveSection(section: 'info' | 'details') {
  this.api.updateAccount(this.editableAccount).subscribe({
    next: (resp: any) => {
      console.log('Cuenta actualizada correctamente');
      this.account = { ...this.editableAccount };

      if (section === 'info') this.editInfo = false;
      if (section === 'details') this.editDetails = false;
    },
    error: (err) => {
      console.error('Error al actualizar cuenta:', err);
    }
  });
}

  getIndustries() {
    this.api.getIndustrias().subscribe({
      next: (data: any) => {
        this.industrias = data.data;
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  openSendMail() {
    this.dialog.open(MdlSendMail, {
      minWidth: '750px',
      maxHeight: '700px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'add', // o 'edit'
        mailData: { // Datos iniciales opcionales
          from: 'usuario@empresa.com',
          asunto: 'Asunto predefinido'
        },
        destinatarios: ['cliente@empresa.com'],
        tipo: 'individual'
      }
    });
  }

}